// src/AdminDashboard/components/MultiStepGameForm/GamePreview/CompletionPreview.js
import React from "react";
import Logo from "../../../../Logo";
import { getSelectedLogoUrl } from "../../../../Logo";

const CompletionPreview = ({ formData, dynamicStyles, client }) => {
  const isMemory = formData.type === "memory";
  const categories = isMemory ? [] : Object.entries(formData.gameData || {});
  const memoryPairCount = Array.isArray(formData?.gameData?.pairs)
    ? formData.gameData.pairs.length
    : 0;
  const selectedLogoUrl = getSelectedLogoUrl(client, formData?.reveal);

  return (
    <div className="completion-preview" style={dynamicStyles}>
      <div className="preview-logo">
        <Logo client={client} logoUrl={selectedLogoUrl} />
      </div>

      <div className="success-message">
        {formData.successMessage || "Congratulations, you got it!"}
      </div>

      <div className="categories-container">
        {isMemory ? (
          <div className="category-block" style={{ "--category-color": "#333" }}>
            <div className="category-title">Memory Game</div>
            <div className="category-words">
              {memoryPairCount} pair{memoryPairCount === 1 ? "" : "s"}
            </div>
          </div>
        ) : (
          categories.map(([categoryName, words], index) => (
            <div
              key={index}
              className="category-block"
              style={{
                "--category-color": formData.categoryColors[index] || "#333",
              }}
            >
              <div className="category-title">{categoryName}</div>
              <div className="category-words">{words.join(", ")}</div>
            </div>
          ))
        )}
      </div>

      {formData.redirectButtonText && (
        <a
          href={formData.redirectButtonLink || "#"}
          className="redirect-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          {formData.redirectButtonText}
        </a>
      )}
    </div>
  );
};

export default CompletionPreview;
